export type userState = {
  user: any;
  token: string;
};

export const GET_USER = 'users/GET_USER';
export const SET_USER = 'users/SET_USER';

export const LOGIN = 'users/LOGIN';
export const SET_TOKEN = 'users/SET_TOKEN';

export const SET_USERS = 'users/SET_USERS';
export const GET_USERS = 'users/GET_USERS';
export const LOGOUT = 'users/LOGOUT';
